<template>
  <Transition name="message-fade" @after-leave="handleAfterLeave">
    <div
      v-show="visible"
      class="message"
      :class="[`message-${type}`, center ? 'is-center' : '']"
      :style="customStyle"
      @mouseenter="clearTimer"
      @mouseleave="startTimer"
    >
      <div class="message-content">
        <IconFont name="icon_sort" class="mr-8" :size="22" />
        <slot>
          <span v-if="!dangerouslyUseHTMLString">{{ message }}</span>
          <span v-else v-html="message"></span>
        </slot>
      </div>
      <!-- <div v-if="showClose" class="message-close-btn" @click="close">
                <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z" />
                </svg>
            </div> -->
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, watch } from 'vue';
import IconFont from './IconFont.vue';

const props = defineProps({
  message: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: 'info',
    validator: (val) => ['success', 'warning', 'info', 'error'].includes(val),
  },
  duration: {
    type: Number,
    default: 3000,
  },
  showClose: {
    type: Boolean,
    default: false,
  },
  center: {
    type: Boolean,
    default: false,
  },
  offset: {
    type: Number,
    default: 20,
  },
  onClose: {
    type: Function,
    default: null,
  },
  dangerouslyUseHTMLString: {
    type: Boolean,
    default: false,
  },
  id: {
    type: String,
    default: '',
  },
});

const visible = ref(false);
const closed = ref(false);
const timer: any = ref(null);

const customStyle = computed(() => ({
  top: `${props.offset}px`,
}));

const startTimer = () => {
  if (props.duration > 0) {
    timer.value = setTimeout(() => {
      if (!closed.value) {
        close();
      }
    }, props.duration);
  }
};

const clearTimer = () => {
  clearTimeout(timer.value);
  timer.value = null;
};

const close = () => {
  closed.value = true;
  if (typeof props.onClose === 'function') {
    props.onClose();
  }
};

const handleAfterLeave = () => {
  // 触发父组件销毁逻辑
};

onMounted(() => {
  visible.value = true;
  startTimer();
});

watch(closed, (newVal) => {
  if (newVal) {
    visible.value = false;
  }
});

defineExpose({
  close,
});
</script>

<style lang="scss" scoped>
.message {
  height: 42px;
  /* min-width: 380px; */
  padding: 0 27px 0 29px;
  box-sizing: border-box;
  border-radius: var(--border-radius);
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(94deg, #a065ff 0%, #4b8ff9 62%, #24d692 100%);
  box-shadow: 0px 4px 6px 0px rgba(160, 101, 255, 0.2);
  transition: opacity 0.3s, transform 0.4s, top 0.4s;
  overflow: hidden;
  padding: 15px 15px 15px 20px;
  display: flex;
  align-items: center;
  z-index: 9999;
}

.message.is-center {
  justify-content: center;
}

.message-content {
  padding: 0;
  font-size: 14px;
  line-height: 1;
}

.message-close-btn {
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  cursor: pointer;
  color: #c0c4cc;
  font-size: 16px;
  margin-left: 10px;
}

.message-close-btn:hover {
  color: #909399;
}

.message-close-btn svg {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

.message-success {
  background: linear-gradient(
    94deg,
    rgba(160, 101, 255, 0.4) 0%,
    rgba(75, 143, 249, 0.4) 62%,
    rgba(36, 214, 146, 0.4) 100%
  );
  color: #fff;
  backdrop-filter: blur(10px);
}

.message-warning {
  background-color: #fdf6ec;
  border-color: #faecd8;
  color: #e6a23c;
}

.message-info {
  background-color: #edf2fc;
  border-color: #ebeef5;
  color: #909399;
}

.message-error {
  background-color: #fef0f0;
  border-color: #fde2e2;
  color: #f56c6c;
}

.message-fade-enter-from,
.message-fade-leave-to {
  opacity: 0;
  transform: translate(-50%, -100%);
}
</style>
